export const stagingConfig = {
  production: false,
  env: 'staging',
  SERVER_ADDR: 'https://devapi.pixelone.app/ems/',
  TRACK_SERVER_ADDR: 'https://devapi.pixelone.app/public/',
  ADMIN_SERVER_ADDR: 'https://devapi.pixelone.app/admin/',
  ANALYTICS_SERVER_ADDR: 'https://devapi.pixelone.app/analytics',
  SUB_URI_V2: 'api/v2/',
  VERSION: '1.0.0.220115',
  TOOLBAR_COLOR: 'accent',
  SHOPIFY_FLOW: 'list',
  STRIPE_PUBLISHABLE_KEY:
    'pk_test_51NcENzH7ijxCcBHidvj0N4RirL6xw4R4xlXdYH8Ge0eDpbwW2KLR9HgHJKJ8GLdI0I0LXa30IhVqblGPkK9aVicg00RIJb8wi2',
}
